export function OpenOrdersCtrl (
  $scope,
  $state,
  $translate,
  jsonApi,
  messages,
  orders,
  tableApi,
  workshopAPI
) {
  $scope.loaded         = true;
  $scope.orders         = orders;
  $scope.tableCacheKey  = 'openOrders';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'order_number',
        header: {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER')
        },
      },
      {
        field : 'order_date',
        header: {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_DATE')
        },
      },
      {
        field : 'vendor_name',
        header: {
          text: $translate.instant('VENDOR_SPACE.SUPPLIER')
        },
      },
      {
        field : 'total',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency',
      }
    ],
    empty: {
      text: $translate.instant('PRODUCT_SPACE.ORDERS.NO_ORDERS')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/dashboard/widget_stats', [
        jsonApi.parse(localStorage.getItem('dashboardTaxSwitch')) === false ? 'false': 'true',
        jsonApi.parse(localStorage.getItem('dashboardMTDSwitch')) === false ? 'false': 'true'
      ]).then(data => data.open_orders)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'order_number'
    })
  };

  $scope.getOrders = ( params ) => {
    return workshopAPI.get('/dashboard/open_orders_list', [
      params.pageSize,
      params.offset,
      params.field,
      params.direction
    ]).then(orders => {
      $scope.orders = orders;

      return orders;
    });
  };

  $scope.onRowClick = function(event) {
    $state.go('app.purchase-order', {
      vendor_id: event.row.vendor_id,
      id       : event.row.id
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED') , 'success');
  };
};